import type {ReactElement} from 'react';
import React from 'react';
import {useGetSlideShowItemWithSelectedImageSlide} from '@Hooks/poster-editor/useGetSlideShowItemWithSelectedImageSlide';
import {BaseImageMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-image-media-controls';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {onReplaceMediaSlide} from '@PosterWhiteboard/page/replace-item.class';

export function ImageSlideMediaControls(): ReactElement<any> {
  const {activeSlide} = useGetSlideShowItemWithSelectedImageSlide();

  const replaceImageSlide = (itemToReplaceWith: ItemData): void => {
    onReplaceMediaSlide(itemToReplaceWith);
  };

  return <BaseImageMediaControls onReplaceImage={replaceImageSlide} activeItem={activeSlide} />;
}
